import * as actionTypes from 'constants/ActionTypes';

export function getCargoRealNames() {
    return {
        type: actionTypes.GET_CARGO_REAL_NAMES.REQUEST,
    };
}

export function updateCargoRealName(item) {
    return {
        type: actionTypes.UPDATE_CARGO_REAL_NAME.REQUEST,
        item,
    };
}

export function deleteCargoRealName(item) {
    return {
        type: actionTypes.DELETE_CARGO_REAL_NAME.REQUEST,
        item,
    };
}

export function searchCargoRealNames(search) {
    return {
        type: actionTypes.SEARCH_CARGO_REAL_NAMES,
        search,
    };
}

export function saveStatusCargoRealName(item) {
    return {
        type: actionTypes.SAVE_STATUS_CARGO_REAL_NAME,
        item,
    };
}

export function updateTagsDataInRow(_id, tags) {
    return {
        type: actionTypes.UPDATE_TAGS_DATA_IN_ROW,
        _id,
        tags,
    };
}

export function getCargoRealNamesPaginated(opts) {
    return {
        type: actionTypes.GET_CARGO_REAL_NAMES_PAGINATED.REQUEST,
        opts,
    };
}



// WEBPACK FOOTER //
// ./app/actions/cargoes/realNames.js